// extracted by mini-css-extract-plugin
module.exports = {"container":"yh-z","heading":"zh-z","links":"Ah-z","linkBtn":"Bh-z","disabled":"Ch-z","linkUppercaseBold":"Dh-z","copy":"Eh-z","subCopy":"Fh-z"};